import React from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';

const Loading = ({ isLoading, height, mobileHeight }) => {
  const isMobile = useMedia('(max-width: 767px)');
  return isLoading ? <div className="ck-loading" style={{ height: isMobile ? mobileHeight || height : height }} /> : null;
};

Loading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  height: PropTypes.string,
  mobileHeight: PropTypes.string,
};

Loading.defaultProps = {
  height: null,
  mobileHeight: null,
};

export { Loading };
